import type { SVGProps } from 'react';

const SvgFacebook = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 10 16" {...props}>
    <path
      fill={props.color}
      fillRule="evenodd"
      d="M2.843 15.995V8.769H0V6.192h2.844V3.813C2.844 1.415 4.404 0 6.764 0c1.129 0 2.05.111 2.335.144v2.694l-1.9-.001c-1.282 0-1.522.579-1.522 1.389v1.966h3.286L8.5 8.769H5.677v7.226H2.843Z"
      clipRule="evenodd"
    />
  </svg>
);

export default SvgFacebook;
